import { neutral1, neutral7 } from '../../colors';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    color: neutral7,
    '& p a:nth-of-type(4)': {
      marginRight: 'auto',
      marginLeft: 'auto',
    },
  },
  caption: {
    fontSize: idsTokens.typography.font.size.sm,
    lineHeight: idsTokens.typography.lineHeight.sm,
    letterSpacing: idsTokens.typography.spacing.letter.md,
    fontWeight: idsTokens.typography.font.weight.medium,
  },
  toolbar: {
    borderTop: `1px solid ${neutral1}`,
    height: 56,
  },
  spacer: {
    flex: 'unset',
  },
  selectRoot: {
    marginLeft: 0,
    marginRight: 0,
  },
  select: {
    paddingRight: '30px !important',
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 12,
  },
  input: {
    marginLeft: 10,
    marginRight: 10,
  },
  selectIcon: {
    top: 'calc(50% - 12px)',
    color: 'inherit',
  },
});
